/*
 * VULCAN
 */
export var RoadmapPerformanceResponse = {
    serializedName: "RoadmapPerformanceResponse",
    type: {
        name: "Composite",
        className: "RoadmapPerformanceResponse",
        modelProperties: {
            lastMonth: {
                required: true,
                serializedName: "lastMonth",
                type: {
                    name: "Number"
                }
            },
            lastSixMonths: {
                required: true,
                serializedName: "lastSixMonths",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var RoadmapFeatureResponse = {
    serializedName: "RoadmapFeatureResponse",
    type: {
        name: "Composite",
        className: "RoadmapFeatureResponse",
        modelProperties: {
            businessAnalyst: {
                required: true,
                serializedName: "businessAnalyst",
                type: {
                    name: "String"
                }
            },
            delivery: {
                serializedName: "delivery",
                type: {
                    name: "String"
                }
            },
            description: {
                required: true,
                serializedName: "description",
                type: {
                    name: "String"
                }
            },
            isOverdue: {
                required: true,
                serializedName: "isOverdue",
                type: {
                    name: "Boolean"
                }
            },
            status: {
                required: true,
                serializedName: "status",
                type: {
                    name: "String"
                }
            },
            target: {
                serializedName: "target",
                type: {
                    name: "String"
                }
            },
            title: {
                required: true,
                serializedName: "title",
                type: {
                    name: "String"
                }
            },
            workItemNumber: {
                required: true,
                serializedName: "workItemNumber",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var RoadmapResponse = {
    serializedName: "RoadmapResponse",
    type: {
        name: "Composite",
        className: "RoadmapResponse",
        modelProperties: {
            area: {
                required: true,
                serializedName: "area",
                type: {
                    name: "String"
                }
            },
            features: {
                required: true,
                serializedName: "features",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "RoadmapFeatureResponse"
                        }
                    }
                }
            },
            performance: {
                serializedName: "performance",
                type: {
                    name: "Composite",
                    className: "RoadmapPerformanceResponse"
                }
            }
        }
    }
};
export var RoadmapListResponse = {
    serializedName: "RoadmapListResponse",
    type: {
        name: "Composite",
        className: "RoadmapListResponse",
        modelProperties: {
            performance: {
                required: true,
                serializedName: "performance",
                type: {
                    name: "Composite",
                    className: "RoadmapPerformanceResponse"
                }
            },
            roadmaps: {
                required: true,
                serializedName: "roadmaps",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "RoadmapResponse"
                        }
                    }
                }
            }
        }
    }
};
export var ServiceErrorResponse = {
    serializedName: "ServiceErrorResponse",
    type: {
        name: "Composite",
        className: "ServiceErrorResponse",
        modelProperties: {
            errorType: {
                required: true,
                serializedName: "errorType",
                type: {
                    name: "String"
                }
            },
            message: {
                required: true,
                serializedName: "message",
                type: {
                    name: "String"
                }
            },
            method: {
                required: true,
                serializedName: "method",
                type: {
                    name: "String"
                }
            },
            statusCode: {
                required: true,
                serializedName: "statusCode",
                type: {
                    name: "Number"
                }
            },
            url: {
                required: true,
                serializedName: "url",
                type: {
                    name: "String"
                }
            },
            details: {
                required: true,
                serializedName: "details",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var StatusPageComponentResponse = {
    serializedName: "StatusPageComponentResponse",
    type: {
        name: "Composite",
        className: "StatusPageComponentResponse",
        modelProperties: {
            id: {
                required: true,
                serializedName: "id",
                type: {
                    name: "String"
                }
            },
            name: {
                required: true,
                serializedName: "name",
                type: {
                    name: "String"
                }
            },
            description: {
                required: true,
                serializedName: "description",
                type: {
                    name: "String"
                }
            },
            position: {
                required: true,
                serializedName: "position",
                type: {
                    name: "Number"
                }
            },
            createdTime: {
                required: true,
                serializedName: "createdTime",
                type: {
                    name: "String"
                }
            },
            updatedTime: {
                required: true,
                serializedName: "updatedTime",
                type: {
                    name: "String"
                }
            },
            status: {
                required: true,
                serializedName: "status",
                type: {
                    name: "Enum",
                    allowedValues: [
                        "operational",
                        "under_maintenance",
                        "degraded_performance",
                        "partial_outage",
                        "major_outage"
                    ]
                }
            },
            onlyShowIfDegraded: {
                required: true,
                serializedName: "onlyShowIfDegraded",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var StatusPageStatusSummaryResponse = {
    serializedName: "StatusPageStatusSummaryResponse",
    type: {
        name: "Composite",
        className: "StatusPageStatusSummaryResponse",
        modelProperties: {
            name: {
                required: true,
                serializedName: "name",
                type: {
                    name: "String"
                }
            },
            description: {
                required: true,
                serializedName: "description",
                type: {
                    name: "String"
                }
            },
            statusTitle: {
                required: true,
                serializedName: "statusTitle",
                type: {
                    name: "String"
                }
            },
            statusBackgroundColor: {
                required: true,
                serializedName: "statusBackgroundColor",
                type: {
                    name: "String"
                }
            }
        }
    }
};
//# sourceMappingURL=mappers.js.map